// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3pOWx","colCheckbox":"styles_colCheckbox__pMiGh"};